import { Avatar } from '@galaxy-ds/core';
import { LawyerConnectionUser } from '@law-connect/types';
import React, { FC, useMemo, useState } from 'react';

interface Props {
  user: LawyerConnectionUser | null;
  userImageClassName?: string;
}

export const UserAvatarComponent: FC<Props> = (props) => {
  const { user, userImageClassName } = props;
  const [userError, setUserError] = useState(false);
  // we want to remove the default gravatar image as that is blank
  const userPicture: string | null = useMemo(() => {
    return /gravatar.*d=blank/.test(user?.picture ?? '') ? null : user?.picture;
  }, [user?.picture]);

  if (!user) {
    return null;
  }

  return userPicture && !userError ? (
    <Avatar
      src={user.picture}
      alt='user'
      className={userImageClassName}
      onError={() => {
        setUserError(true);
      }}
    />
  ) : (
    <Avatar className={userImageClassName}>
      {user.firstName?.length ? user.firstName[0] : ''}
      {user.lastName?.length ? user.lastName[0] : ''}
    </Avatar>
  );
};
